module.exports = __webpack_public_path__ + "static/media/clock.6e3e68ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/assessment/clock.svg
// module id = 2879
// module chunks = 3